import { getOpenIdEndpoint } from "../openIdAuthCreator/getOpenIdEndpoint";
import { EAuthStrategy } from "../../interfaces/EAuthStrategy";
export const API_PATH_apiAuthOhioOpenIdMethodRedirect = ({ host, companyId, }) => getOpenIdEndpoint({
    host,
    strategy: EAuthStrategy.OAUTH_OPENID_OHIO,
    endpoint: "client",
    companyId,
});
